<mat-nav-list
  class="navigation-menu-panel"
  *ngIf="!(breakpointObserverService.isMobile | async)"
>
  <!-- The full horizontal lockup, not the standalone mark: this rail is the
       app's only logo whenever it is on screen, because app-top-nav hides its
       own copy at exactly these widths (see that component's
       sidenav-rail-visible mixin). Plain <img>, matching app-top-nav, rather
       than app-icon/MatIconRegistry - the SVG carries id-referenced gradients
       that collide when the same markup is inlined more than once. A data URI
       keeps that property, since every <img> is its own document, and costs
       one round trip less on first paint. -->
  <button
    #moreMenuToggle
    type="button"
    class="logo-lockup more-menu-toggle"
    (click)="toggleMoreMenu()"
    [attr.aria-expanded]="isMoreMenuOpen"
    aria-haspopup="true"
    aria-controls="more-menu"
    aria-label="More options"
  >
    <img [src]="logoSrc" alt="Map AI" width="141" height="68" />
  </button>

  <div class="desktop-pointer"></div>

  <div class="navmenu-links">
    @for (item of navItems; track item.link) {
      <a
        [routerLink]="item.link"
        [class.active-link]="isActive(item)"
        [matTooltip]="item.tooltip"
        matTooltipPosition="right"
      >
        <app-icon [svgIcon]="item.icon"></app-icon>
        <span>{{ item.label }}</span>
      </a>
    }
  </div>

  <div class="user-icon-container">
    <a
      *ngIf="accessService.getIsAdmin()"
      [routerLink]="'admin'"
      matTooltip="Manage users and platform settings"
      matTooltipPosition="right"
    >
      <app-icon
        routerLinkActive="active-link"
        svgIcon="adminPanel"
        class="admin-icon"
      ></app-icon>
    </a>
    <a
      class="account-link"
      routerLinkActive="active-link"
      [routerLink]="authService.hasAccessToken() ? 'user' : 'sign-in'"
      [matTooltip]="
        authService.hasAccessToken()
          ? 'Manage your subscription and account'
          : 'Log in to access premium features'
      "
      matTooltipPosition="right"
    >
      <span class="user-icon-circle">
        <app-icon svgIcon="user" class="user-icon"></app-icon>
      </span>
      <span class="account-label">{{ accountLabel }}</span>
    </a>
  </div>
</mat-nav-list>

<nav
  id="more-menu"
  class="more-menu-panel more-menu-panel-desktop"
  *ngIf="!(breakpointObserverService.isMobile | async)"
  [class.open]="isMoreMenuOpen"
  aria-label="More"
>
  <ng-container *ngTemplateOutlet="moreMenuLinks"></ng-container>
</nav>

<nav
  class="navigation-menu-panel-mobile"
  *ngIf="breakpointObserverService.isMobile | async"
>
  <!-- The mark leads the bar and the rule separates it from the destinations,
       so the brand reads as a brand rather than as a sixth tab. -->
  <button
    #moreMenuToggle
    type="button"
    class="more-menu-toggle brand-toggle"
    (click)="toggleMoreMenu()"
    [attr.aria-expanded]="isMoreMenuOpen"
    aria-haspopup="true"
    aria-controls="more-menu"
    aria-label="More options"
  >
    <img
      src="/assets/icons/navigation-menu/logo.svg"
      alt=""
      width="24"
      height="21"
    />
  </button>

  <span class="brand-divider" aria-hidden="true"></span>

  <div class="navmenu-links">
    @for (item of navItems; track item.link) {
      <a [routerLink]="item.link" [class.active-link]="isActive(item)">
        <app-icon [svgIcon]="item.icon"></app-icon>
        <span>{{ item.shortLabel }}</span>
      </a>
    }

    <a
      *ngIf="accessService.getIsAdmin()"
      [routerLink]="'/admin'"
      routerLinkActive="active-link"
    >
      <app-icon svgIcon="adminPanel" class="admin-icon"></app-icon>
      <span>Admin</span>
    </a>

    <a
      [routerLink]="authService.hasAccessToken() ? 'user' : 'sign-in'"
      routerLinkActive="active-link"
    >
      <app-icon svgIcon="user"></app-icon>
      <span>{{ accountLabel }}</span>
    </a>
  </div>

  <nav
    id="more-menu"
    class="more-menu-panel"
    [class.open]="isMoreMenuOpen"
    aria-label="More"
  >
    <ng-container *ngTemplateOutlet="moreMenuLinks"></ng-container>
  </nav>
</nav>

<ng-template #moreMenuLinks>
  <a href="/explore/us/overview" (click)="closeMoreMenu()">Explore US Data</a>
  <a routerLink="/comparative-location-tool" (click)="closeMoreMenu()"
    >Compare Locations</a
  >
  @for (link of tradeAreaLinks; track link.path) {
    <a [routerLink]="link.path" (click)="closeMoreMenu()">{{ link.label }}</a>
  }
  <a [href]="blogUrl" (click)="closeMoreMenu()">Blog</a>
  <a routerLink="/info/data-sources" (click)="closeMoreMenu()">Data Sources</a>
  <a routerLink="/pricing" (click)="closeMoreMenu()">Pricing</a>
</ng-template>
